var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#refresh_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.382 7.063a2 2 0 0 0-2.174 1.81l-.265 2.907C42.447 4.72 34.643 0 25.6 0 15.872 0 7.299 5.552 3.043 13.885a2 2 0 1 0 3.562 1.82C10.207 8.652 17.44 4 25.6 4c7.438 0 14.15 3.873 17.995 9.94l-2.851-2.036a2 2 0 0 0-2.325 3.255l8.647 6.176c1.268.904 3.016.077 3.154-1.446l.971-10.653a2 2 0 0 0-1.81-2.173M47.286 34.624a2 2 0 0 0-2.691.871C40.993 42.548 33.76 47.2 25.6 47.2c-7.438 0-14.15-3.873-17.995-9.94l2.851 2.036a2 2 0 0 0 2.325-3.255l-8.647-6.176C2.882 28.97 1.12 29.773.98 31.31L.009 41.964a2 2 0 0 0 3.983.363l.265-2.907C8.753 46.48 16.557 51.2 25.6 51.2c9.728 0 18.301-5.552 22.557-13.885a2 2 0 0 0-.871-2.691"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "refresh_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h51.2v51.2H0z"
  })))));
};
export default SvgRefresh;